// Slider op 50% zetten
document.addEventListener('DOMContentLoaded', function() {
  var sliders = document.querySelectorAll('.u-size-bar__slider');
  sliders.forEach(function(slider) {
    slider.value = 50;
  });
  // Thumb positie ook visueel updaten
  var tracks = document.querySelectorAll('.u-size-bar__track');
  tracks.forEach(function(track) {
    var before = track.querySelector('::before');
    if (before) before.style.left = '50%';
  });
});
